module.exports = __webpack_public_path__ + "static/media/hackathon.619a1f71.jpg";